export enum LookBookProductType {
  Triplex = 'Triplex',
  WellDecor = 'WallDecor',
  Tambour = 'Tambour',
  'ZalamoCalendar' = 'ZalamoCalendar',
}
